import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Button,
} from '@material-ui/core';
import Title from './Title';
import { validarSoloUnPermiso } from '../../../../../helpers/permisos';
import { RECETAS_MENU_PERMISOS } from '../../../../../utils/permisos';
import {
  STEPPER_RECETAS,
} from '../../../../../utils/constants';
import {
  clearReducer,
  getRecetasHistorialPrevio,
  setActiveStep,
  setAfiliadoSeleccionado,
} from '../../../../../actions/recetasDigitales/RecetasDigitales';
import { useState } from 'react';
import { RecetasDigitalesHistorialItem } from '../../../../recetasDigitales/Ingreso/RecetasDigitalesHistorialItem';
import { ModalRecetasHCE } from '../../../Empadronamientos/ModalRecetasHce';


export const TabRecetas = (props) => {
    const dispatch = useDispatch();
  const { hce, dataAfiliado, disabled } = props;
  const [openModalReceta, setOpenModalReceta] = useState(false);
  const { recetas } = useSelector((state) => state.recetasDigitales);
  const { permisos: permisosUser } = useSelector((state) => state.auth);

  useEffect(() => {
    if (hce.idAfiliado) {
      dispatch(getRecetasHistorialPrevio(hce?.idAfiliado));
      dispatch(clearReducer());
    }
  }, [dispatch]);


    return (
        <React.Fragment>
            {openModalReceta &&
                <ModalRecetasHCE
                    open={openModalReceta}
                    close={() => {
                        setOpenModalReceta(false);
                    }}
                    hce={hce}
                    dataAfiliado={dataAfiliado}

                />

            }
            <Title>
                Recetas{' '}
                {validarSoloUnPermiso(
                    permisosUser,
                    RECETAS_MENU_PERMISOS.INGRESO_RECETAS,
                ) &&
                    //areas.filter((area) => area.idArea === AREAS_USUARIOS.CENTROS_MEDICOS)
                    //.length > 0 && 
                    (
                        <>
                            {!disabled &&
                                <Button
                                    disabled={disabled}
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    onClick={() => {
                                        dispatch(setAfiliadoSeleccionado(dataAfiliado));
                                        dispatch(setActiveStep(STEPPER_RECETAS.DATOS_TITULAR));
                                        setOpenModalReceta(true)
                                    }}
                                >
                                    + Ingresar Receta
                                </Button>
                            }
                        </>

                    )}
            </Title>
            {Array.isArray(recetas) && recetas?.length > 0 ? (
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell style={{ width: '7%' }}>Estado</TableCell>
                            <TableCell style={{ width: '6%' }}>Receta</TableCell>
                            <TableCell style={{ width: '10%' }}>Fecha</TableCell>
                            <TableCell style={{ width: '15%' }}>Tipo Receta</TableCell>
                            <TableCell style={{ width: '5%' }}>Medicamentos</TableCell>
                            <TableCell style={{ width: '30%' }}>Diagnóstico</TableCell>
                            {<TableCell style={{ width: '17%' }}>Médico</TableCell>}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {recetas.map((receta, index) => {
                            return (
                                <RecetasDigitalesHistorialItem
                                    key={receta?.idRecetaDigital.toString()}
                                    receta={receta}
                                />
                            );
                        })}
                    </TableBody>
                </Table>
            ) : (
                <Typography style={{ fontSize: '1.1rem', fontStyle: 'italic' }}>
                    No hay Recetas
                </Typography>
            )}
        </React.Fragment>
    )
}
